import { render, staticRenderFns } from "./AddOrUpdate.vue?vue&type=template&id=5b3b3a9d&scoped=true&"
import script from "./AddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdate.vue?vue&type=style&index=0&id=5b3b3a9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b3a9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3b3a9d')) {
      api.createRecord('5b3b3a9d', component.options)
    } else {
      api.reload('5b3b3a9d', component.options)
    }
    module.hot.accept("./AddOrUpdate.vue?vue&type=template&id=5b3b3a9d&scoped=true&", function () {
      api.rerender('5b3b3a9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/SubForm/AddOrUpdate.vue"
export default component.exports